import React from 'react';
import { useEffect, useState, useRef } from "react";
import {Col, Row, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { APIUS } from "../../../../../config/apius";
import ReactPaginate from "react-paginate";
import "bulma/css/bulma.css";
import "../../../../../index.css";
// import "./Dashboard.css";
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { Autosave, useAutosave } from 'react-autosave';
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import Select from 'react-select';
import Chart from 'react-apexcharts';
// import ModalRapor from './modal/rapor';

export default function Home() {
  document.title = "Dashboard";
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [ascending, setAscending] = useState(1);
  const [descending, setDescending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const token = localStorage.getItem("token");

  // Responsive to mobile or dekstop
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)'});
  const [loading, setLoading] = useState(false);
  const storageBranchGroping = localStorage.getItem('ysb_branch_id');
  const storageLevel = localStorage.getItem('level');
   
  // Data
  const [storageBranch, setStorageBranch] = useState("");
  const [storageSchool, setStorageSchool] = useState("");
  const [storageTeacher, setStorageTeacher] = useState("");
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataDimensiDefault, setGetDataDimensiDefault] = useState([]);
  const [getDataSemester, setGetDataSemester] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataTeacher, setGetDataTeacher] = useState([]);
  const [selectKey, setSelectKey] = useState(0);
  const [getData, setGetData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(null);
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  // const [getRapor, setGetRapor] = useState([]);
  const [pages, setPages] = useState(1);
  // const [showModal, setShowModal] = useState(false);
  // const [selectedRapor, setSelectedRapor] = useState(null);

  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStudentDetail, setSelectedStudentDetail] = useState(null);
  const [selectedStudentIndicators, setSelectedStudentIndicators] = useState([]);

  // Dashboard-specific states for "Opsi A" (group by student)
  const [lowItems, setLowItems] = useState([]); // raw indicators with value < 4
  const [studentsLow, setStudentsLow] = useState([]); // grouped per-student (only low indicators)
  const [studentsAll, setStudentsAll] = useState([]); // grouped per-student (all indicators)
  const [onlyLow, setOnlyLow] = useState(true); // toggle: show only indicators < 4
  const [searchTerm, setSearchTerm] = useState(""); // search by name/nisn
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedIndicators, setSelectedIndicators] = useState([]);

  const [namaTA, setNamaTA] = useState([]);
  const [namaSmstr, setNamaSmstr] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  // Dashboard statistics
  const [stats, setStats] = useState({
    totalStudents: 0,
    avgValue: 0,
    needAttention: 0,
    progressPercent: 0,
    weakestElement: null
  });

  const [top5Weakest, setTop5Weakest] = useState([]);
  const [kkcaDistribution, setKkcaDistribution] = useState([]);

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();
  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname]);

  useEffect(() => {
    setStorageBranch(localStorage.getItem('ysb_branch_id') || "");
    setStorageSchool(localStorage.getItem('ysb_school_id') || "");
    setStorageTeacher(localStorage.getItem('teacherID') || "");
  }, [])

  // const id_teacher = localStorage.getItem('teacherID');
  // console.log(id_teacher);

  const [form, setForm] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id:"",
    ysb_teacher_id: ""
  });

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id:"",
    ysb_teacher_id: "",
    ysb_sub_element_value:"",
  });

   const [form3, setForm3] = useState({
    ysb_element_recap_id_id:"",
    ysb_sub_element_value:"",
  });

 

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  // guard to prevent duplicate auto-fetch of dashboard endpoint
  const dashboardAutoFetchedRef = useRef(false);
  const raporAutoFetchedRef = useRef(false);
  const lastFetchParamsRef = useRef(null);

  const fetchDataRef = useRef();
  const fetchData = async () => {
    try {
      // setLoading(true);
      const [ dataSemester, dataDimensi] = await axios.all([
        // APILA.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,fetchParams),
        APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,fetchParams),
        APILA.get(`/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,fetchParams),
      ]);
      if (dataSemester.status === 200  && dataDimensi.status === 200 ){
        const semesters = dataSemester.data.data.find(s => s.status === 1);
        // setGetDataBranch(dataBranch.data.data);
        setGetDataSemester(semesters);
        setGetDataSemesterMap(dataSemester.data.data);
        setGetDataDimensi(dataDimensi.data.data);
        setGetDataDimensiDefault(dataDimensi.data.data[0]);
        setNamaTA(semesters.name_year);
        setNamaSmstr(semesters.semester);
        // setLoading(false);
      }
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };
  
  useEffect(() => {
    fetchDataRef.current = fetchData;
    fetchDataRef.current();
  }, []);

  // Get data awal ketika render halaman pertama kali
  useEffect(() => {
    const first = getData?.[0]?.data_element?.[0]?.name_description;
    if (first) setSelectedTab(prev => prev || first);
  }, [getData]);

  // open modal preview for a rapor
  // const viewModalRapor = (id, rapor) => {
  //   try {
  //     setSelectedRapor(rapor ?? null);
  //     setShowModal(true);
  //   } catch (err) {
  //     console.error('viewModalRapor error', err);
  //   }
  // };

  const GetResponseData = async () => {
    try {
      setLoading(true);

      const params = {
        ysb_semester_id: form?.ysb_semester_id || getDataSemester?.id,
        level: storageLevel,
        branch: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher
      };

      console.log('🔍 GetResponseData params:', params);

      const response = await APILA.get('/api/dashboards-teacher', {
        params,
        ...fetchParams
      });

      console.log('✅ API Response:', response.data);

      if (response?.status === 200) {
        // ✅ BACKEND BARU: response.data.stats_info sudah provide semua stats!
        const statsInfo = response.data?.stats_info || {};
        const chartData = response.data?.chart_data || {};
        const respData = response.data?.data || {};
        const items = respData.items || []; // flat list of indicators with nilai < 4

        console.log('📊 Stats from backend:', statsInfo);
        console.log('📈 Chart data:', chartData);
        console.log('📋 Items count:', items.length);

        // ✅ STEP 1: Directly use stats from backend (no manual calculation!)
        setStats({
          totalStudents: statsInfo.total_siswa || 0,
          avgValue: statsInfo.rata_rata_nilai || 0,
          needAttention: statsInfo.perlu_perbaikan || 0,
          progressPercent: 100,
          weakestElement: statsInfo.element_terlemah ? {
            name: statsInfo.element_terlemah.split('(')[0].trim(),
            avg: parseFloat(statsInfo.element_terlemah.match(/\d+\.\d+/)?.[0] || 0)
          } : null
        });

        // ✅ Set chart data from backend
        setTop5Weakest(chartData.top_5_weakest || []);
        setKkcaDistribution(chartData.kkca_distribution || []);

        // ✅ STEP 2: Group flat items by student
        const studentMap = new Map();
        items.forEach(item => {
          const studentId = item.ysb_student_id;
          if (!studentMap.has(studentId)) {
            studentMap.set(studentId, {
              ysb_student_id: studentId,
              name_student: item.name_student,
              nisn: item.nisn,
              indicators: []
            });
          }
          
          // Push indicator dengan field mapping BARU
          studentMap.get(studentId).indicators.push({
            nilai_akhir: item.nilai_akhir, // ✅ NEW field (weighted average)
            ysb_sub_element_value: item.nilai_akhir, // ✅ backward compat
            sub_element_name: item.sub_element_name, // ✅ NEW field
            description: item.sub_element_name, // backward compat
            name_element: item.name_element, // ✅ NEW field
            name_description: item.name_element, // backward compat
            element_description: item.element_description,
            kkca_description: item.kkca_description, // ✅ NEW field!
            ysb_element_id: item.ysb_element_id,
            ysb_sub_element_id: item.ysb_sub_element_id
          });
        });

        const groupedStudents = Array.from(studentMap.values());
        console.log('👥 Grouped students:', groupedStudents.length);

        setGetData(groupedStudents);
        setStudentsLow(groupedStudents);
        setLowItems(items);

        // Update fetch tracking
        dashboardAutoFetchedRef.current = true;
        lastFetchParamsRef.current = {
          semester: params.ysb_semester_id,
          branch: params.branch,
          school: params.ysb_school_id,
          teacher: params.ysb_teacher_id
        };

        setLoading(false);
        console.log('✅ GetResponseData completed successfully');
      }

    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseData2 = async () => {
    try {
      setLoading(true);
      const response = await APILA.get('/api/dashboards-teacher', {
        params: {
          level: storageLevel,
          branch: storageBranch,
          ysb_semester_id: form2?.ysb_semester_id,
          // ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: form2?.ysb_school_id || storageSchoolId,
          ysb_teacher_id: form2?.ysb_teacher_id || storageTeacher
        },
        ...fetchParams
      });

      if (response?.status === 200) {
        // setGetRapor(response.data.data || []);
        setPages(response.data.totalPage || 1);
        setLoading(false);
      }

    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const handleChange = (e) => {
    setForm2({
      ...form2,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange2 = (e) => {
    setForm2({
      ...form2,
      ysb_teacher_id: e.value,
    });
  };

  useEffect(() => {
    if (storageBranch !== "") {
      setForm2(prevForm => ({
        ...prevForm,
        ysb_branch_id: storageBranch
      }));      
    }
  }, [storageBranch]);

  useEffect(() => {
    if (storageSchool) {
      setForm2(prev => ({ ...prev, ysb_school_id: storageSchool }));
    }
    if (storageTeacher) {
      setForm2(prev => ({ ...prev, ysb_teacher_id: storageTeacher }));
    }
  }, [storageSchool, storageTeacher]);

  useEffect(() => {
  }, [form2?.ysb_semester_id, form2?.ysb_dimensi_id]);

  useEffect(() => {
    if (getDataSemester?.id && getDataDimensiDefault?.id && !isInitialized) {
      
      setForm({
        ysb_semester_id: getDataSemester.id,
        ysb_dimensi_id: getDataDimensiDefault.id,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher
      });

      setForm2({
        ysb_semester_id: getDataSemester.id,
        ysb_dimensi_id: getDataDimensiDefault.id,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher,
        ysb_sub_element_value: ""
      });

      setIsInitialized(true);
    }
  }, [getDataSemester?.id, getDataDimensiDefault?.id, storageBranch, storageSchoolId, storageTeacher, isInitialized]);

  useEffect(() => {
    if (!isInitialized) {
      console.log('⏸️ Waiting for initialization...');
      return;
    }

    const shouldFetch = 
      form.ysb_semester_id && 
      form.ysb_semester_id !== "" && 
      storageBranch && 
      storageBranch !== "" &&
      storageSchoolId && 
      storageSchoolId !== "" &&
      storageTeacher &&
      storageTeacher !== "";

    if (!shouldFetch) {
      console.log('⏸️ Params not ready yet:', {
        semester_id: form.ysb_semester_id,
        branch: storageBranch,
        school: storageSchoolId,
        teacher: storageTeacher
      });
      return;
    }


    const currentParams = {
      semester: form.ysb_semester_id,
      branch: storageBranch,
      school: storageSchoolId,
      teacher: storageTeacher
    };

    const paramsChanged = !lastFetchParamsRef.current || 
      lastFetchParamsRef.current.semester !== currentParams.semester ||
      lastFetchParamsRef.current.branch !== currentParams.branch ||
      lastFetchParamsRef.current.school !== currentParams.school ||
      lastFetchParamsRef.current.teacher !== currentParams.teacher;

    console.log('🔍 Fetch check:', {
      isInitialized,
      shouldFetch,
      paramsChanged,
      guardRef: dashboardAutoFetchedRef.current,
      currentParams,
      lastParams: lastFetchParamsRef.current
    });

    if (paramsChanged && dashboardAutoFetchedRef.current) {
      console.log('🔄 Params changed, resetting guard...');
      dashboardAutoFetchedRef.current = false;
    }

    if (!dashboardAutoFetchedRef.current || paramsChanged) {
      console.log('🚀 Triggering GetResponseData...');
      GetResponseData();
    } else {
      console.log('⏭️ Skipping fetch - already fetched with same params');
    }
  }, [isInitialized, form.ysb_semester_id, storageBranch, storageSchoolId, storageTeacher]); 

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setKeyword(query);
    }, 300); 

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  // UPDATE NILAI
  const [updateId, setUpdateID] = useState(-1);
  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  return (
    <div className="body" >

      {/* <div className="body-header d-flex">
        {isTabletOrMobile ? 
          <>
            <div className="title-page">
              <h6><FontAwesomeIcon icon={faListUl}/> Dashboard</h6>
            </div> 
          </>
          : 
          <>
            <div className="title-page">
              <h5><FontAwesomeIcon icon={faListUl}/> Dashboard </h5>
            </div>
          </>
        }   
      </div>  */}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          {isTabletOrMobile ? (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGauge} />
                </span>
                <h4 className="page-title-text"> Dashboard</h4>
              </div>
            </>
          ) : (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGauge} />
                </span>
                <h4 className="page-title-text"> Dashboard</h4>
              </div>
            </>
          )}
        </div>
      </div>
      
      <div className="body-content">
        {/* Breadcrumnbs */}
        

        {/* FILTER */}
        {isTabletOrMobile ? 
          <>
            
          </>
          :
          <>

          
          </>
        }

        {loading && <LoaderHome />}

        {/* Summary Cards */}
        <Row className="mb-3">
          {/* Card 1 - Blue accent */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#3b82f6', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#3b82f6'}}>
                👥
              </div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#3b82f6', textTransform:'uppercase', letterSpacing:0.6}}>Total Siswa</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{stats.totalStudents}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>Jumlah siswa remedial</div>
              </div>
            </div>
          </Col>

          {/* Card 2 - Green accent */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#10b981', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#10b981'}}>
                📉
              </div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#10b981', textTransform:'uppercase', letterSpacing:0.6}}>Rata-rata Nilai</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{stats.avgValue}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>Rata-rata nilai siswa remedial</div>
              </div>
            </div>
          </Col>

          {/* Card 3 - Teal accent */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#06b6d4', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#06b6d4'}}>
                ⚠️
              </div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#06b6d4', textTransform:'uppercase', letterSpacing:0.6}}>Perlu Perbaikan</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{stats.needAttention}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>Jumlah siswa perlu perhatian</div>
              </div>
            </div>
          </Col>

          {/* Card 4 - Yellow accent */}
          {/* <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#f59e0b', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#f59e0b'}}>
                
              </div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#f59e0b', textTransform:'uppercase', letterSpacing:0.6}}>Progress Penilaian</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{stats.progressPercent}%</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>Persentase penilaian selesai</div>
              </div>
            </div>
          </Col> */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
          <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
            <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#8b5cf6', borderRadius:'6px 0 0 6px'}} />
                          <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#8b5cf6'}}>
                            📌
                          </div>
                          <div>
                            <div style={{fontSize:11, fontWeight:700, color:'#8b5cf6', textTransform:'uppercase', letterSpacing:0.6}}>Element Terlemah</div>
                            <div style={{fontSize:16, fontWeight:800, color:'#111827', marginTop:6, lineHeight:1.3}}>
                              {stats.weakestElement ? stats.weakestElement.name : '-'}
                            </div>
                            <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>
                              {stats.weakestElement ? `Rata-rata: ${stats.weakestElement.avg}` : 'Tidak ada data'}
                            </div>
                          </div>
                        </div>
                      </Col>
        </Row>

        {/* Element Terlemah Card */}
        {/* {stats.weakestElement && (
          <Row className="mb-4">
            <Col xs={12}>
              <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
                <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#ef4444', borderRadius:'6px 0 0 6px'}} />
                <div style={{position:'absolute', right:12, top:8, fontSize:64, opacity:0.06, color:'#ef4444'}}>
                  📌
                </div>
                <div>
                  <div style={{fontSize:11, fontWeight:700, color:'#ef4444', textTransform:'uppercase', letterSpacing:0.6}}>Element Terlemah</div>
                  <div style={{fontSize:18, fontWeight:800, color:'#111827', marginTop:6}}>
                    {stats.weakestElement.name}
                    <span style={{fontSize:13, fontWeight:600, color:'#6b7280', marginLeft:10}}>(Rata-rata: <strong style={{color:'#d63031'}}>{stats.weakestElement.avg}</strong>)</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )} */}

        {/* Charts Section */}
        <Row className="mb-4">
          <Col xs={12} md={7} className="mb-3 mb-md-0">
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <h6 style={{marginBottom: '15px', color: '#333', fontWeight: 600}}>⚠️ Top 5 Element Terlemah</h6>
              {top5Weakest.length > 0 ? (
                <Chart
                  type="bar"
                  height={isTabletOrMobile ? 250 : 350}
                  series={[{
                    name: 'Rata-rata Nilai',
                    data: top5Weakest.map(d => d.avg)
                  }]}
                  options={{
                    chart: {
                      type: 'bar',
                      toolbar: { show: true }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: true,
                        borderRadius: 6,
                        dataLabels: {
                          position: 'top'
                        },
                        distributed: true
                      }
                    },
                    colors: ['#ef4444', '#f97316', '#fbbf24', '#fb923c', '#fdba74'],
                    dataLabels: {
                      enabled: true,
                      formatter: function (val) {
                        return val.toFixed(2);
                      },
                      offsetX: 30,
                      style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        colors: ['#fff']
                      }
                    },
                    xaxis: {
                      categories: top5Weakest.map(d => d.element.length > 40 ? d.element.substring(0, 40) + '...' : d.element),
                      labels: {
                        style: { fontSize: '11px' }
                      },
                      title: {
                        text: 'Nilai Rata-rata'
                      }
                    },
                    yaxis: {
                      labels: {
                        style: { fontSize: '11px' }
                      }
                    },
                    grid: {
                      xaxis: {
                        lines: { show: true }
                      }
                    },
                    legend: {
                      show: false
                    },
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return 'Rata-rata: ' + val.toFixed(2);
                        }
                      }
                    }
                  }}
                />
              ) : (
                <div style={{padding: 40, textAlign: 'center', color: '#6b7280'}}>
                  <div style={{fontSize: 14, fontWeight: 600}}>Tidak ada data tersedia</div>
                  <div style={{fontSize: 12, marginTop: 6}}>Silakan refresh halaman</div>
                </div>
              )}
            </div>
          </Col>
          
          <Col xs={12} md={5}>
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <h6 style={{marginBottom: '15px', color: '#333', fontWeight: 600}}>🎯 Capaian Adab Siswa</h6>
              {kkcaDistribution.length > 0 && kkcaDistribution.some(d => d.count > 0) ? (
                <>
                  <Chart
                    type="donut"
                    height={isTabletOrMobile ? 220 : 280}
                    series={kkcaDistribution.map(d => d.count)}
                    options={{
                      chart: { type: 'donut' },
                      labels: kkcaDistribution.map(d => d.category),
                      colors: kkcaDistribution.map(d => d.color),
                      legend: {
                        show: false
                      },
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '65%',
                            labels: {
                              show: true,
                              name: {
                                show: true,
                                fontSize: '14px',
                                fontWeight: 600
                              },
                              value: {
                                show: true,
                                fontSize: '20px',
                                fontWeight: 700,
                                formatter: function (val) {
                                  return val;
                                }
                              },
                              total: {
                                show: true,
                                label: 'Total Siswa',
                                fontSize: '13px',
                                fontWeight: 600,
                                formatter: function (w) {
                                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                }
                              }
                            }
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      tooltip: {
                        y: {
                          formatter: function (val, { seriesIndex }) {
                            const item = kkcaDistribution[seriesIndex];
                            return val + ' siswa (' + item.percentage + '%)';
                          }
                        }
                      }
                    }}
                  />
                  
                  {/* Custom Legend */}
                  <div style={{marginTop: 15}}>
                    {kkcaDistribution.map((item, idx) => (
                      <div key={idx} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 8,
                        padding: '8px 12px',
                        backgroundColor: '#f9fafb',
                        borderRadius: 6,
                        borderLeft: `4px solid ${item.color}`
                      }}>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                          <div style={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            backgroundColor: item.color
                          }} />
                          <span style={{fontSize: 12, fontWeight: 500, color: '#374151'}}>
                            {item.category}
                          </span>
                        </div>
                        <div style={{textAlign: 'right'}}>
                          <span style={{fontSize: 13, fontWeight: 700, color: '#111827'}}>
                            {item.count}
                          </span>
                          <span style={{fontSize: 11, color: '#6b7280', marginLeft: 4}}>
                            ({item.percentage}%)
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Insight - Dynamic Attention Based on Highest Count */}
                  {(() => {
                    if (kkcaDistribution.length === 0) return null;
                    
                    // Find max count
                    const maxCount = Math.max(...kkcaDistribution.map(d => d.count));
                    
                    // Find all categories with max count (handle ties)
                    const categoriesNeedAttention = kkcaDistribution
                      .filter(d => d.count === maxCount && d.count > 0)
                      .map(d => d.category);
                    
                    // Calculate total students in attention categories
                    const totalNeedAttention = kkcaDistribution
                      .filter(d => categoriesNeedAttention.includes(d.category))
                      .reduce((sum, d) => sum + d.count, 0);
                    
                    const totalStudents = kkcaDistribution.reduce((sum, d) => sum + d.count, 0);
                    const percentAttention = totalStudents > 0 ? (totalNeedAttention / totalStudents * 100).toFixed(1) : 0;
                    
                    // Determine if good or need attention based on category name
                    const hasLowCategory = categoriesNeedAttention.some(cat => 
                      cat === 'Adab Mulai Terpuji' || cat === 'Adab Cukup Terpuji'
                    );
                    
                    const isGood = !hasLowCategory && categoriesNeedAttention.some(cat => 
                      cat === 'Adab Sangat Terpuji' || cat === 'Adab Terpuji'
                    );
                    
                    // Format category names for display
                    const categoryText = categoriesNeedAttention.length === 1 
                      ? categoriesNeedAttention[0]
                      : categoriesNeedAttention.join(' dan ');
                    
                    return (
                      <div style={{
                        marginTop: 15,
                        padding: 12,
                        backgroundColor: isGood ? '#f0fdf4' : '#fef2f2',
                        borderRadius: 8,
                        borderLeft: `4px solid ${isGood ? '#10b981' : '#ef4444'}`
                      }}>
                        <div style={{
                          fontSize: 11, 
                          fontWeight: 700, 
                          color: isGood ? '#065f46' : '#991b1b', 
                          marginBottom: 4
                        }}>
                          {isGood ? '✅ Kondisi Baik' : '⚠️ Perhatian'}
                        </div>
                        <div style={{
                          fontSize: 11, 
                          color: isGood ? '#064e3b' : '#7f1d1d'
                        }}>
                          {isGood 
                            ? `Mayoritas siswa (${percentAttention}%) berada di kategori ${categoryText}`
                            : `${totalNeedAttention} siswa (${percentAttention}%) memerlukan perhatian di kategori ${categoryText}`
                          }
                        </div>
                      </div>
                    );
                  })()}
                </>
              ) : (
                <div style={{padding: 40, textAlign: 'center', color: '#6b7280'}}>
                  <div style={{fontSize: 14, fontWeight: 600}}>Tidak ada data tersedia</div>
                  <div style={{fontSize: 12, marginTop: 6}}>Silakan refresh halaman</div>
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Col xl='12' sm='12'> 
          <div className="mt-3" style={{
              background: 'white',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
            <div className="body-table" >
              <div>
                <h6 style={{marginBottom: '15px', color: '#333', fontWeight: 600}}>Tabel Siswa Remedial</h6>
                        <table className="table  w-100 table-hover table-bordered" id="basic-datatable">
                          <thead >
                            <tr>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Murid</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">NISN</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Status</th>
                              {/* <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Nilai</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Indikator</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Element</th> */}
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Aksi</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(getData || []).filter(student => {
                              if (!searchTerm) return true;
                              const q = searchTerm.toLowerCase();
                              return (student.name_student || "").toLowerCase().includes(q) || (student.nisn || "").includes(q);
                            }).map((student, studentIndex) => {
                              const indicators = student.indicators || [];
                              const rowSpan = indicators.length || 1;
                              
                              // ✅ Calculate average from nilai_akhir (weighted average)
                              const studentAvg = indicators.length > 0 
                                ? (indicators.reduce((sum, i) => sum + Number(i.nilai_akhir || i.ysb_sub_element_value), 0) / indicators.length).toFixed(1)
                                : 0;
                              
                              // ✅ Get badge based on KKCA description or average
                              // const getBadge = (avg) => {
                              //   if (avg >= 3.5) return { color: '#28a745', icon: '✓', text: 'Baik' };
                              //   if (avg >= 3) return { color: '#ffc107', icon: '⚠', text: 'Cukup' };
                              //   return { color: '#dc3545', icon: '✗', text: 'Perlu Perbaikan' };
                              // };
                              
                              // const badge = getBadge(Number(studentAvg));
                              const badge = (Number(studentAvg));
                              
                              // ✅ Get KKCA description from first indicator (should be same for all)
                              const kkcaDesc = indicators.length > 0 && indicators[0].kkca_description 
                                ? indicators[0].kkca_description 
                                : badge.text;
                              
                              return (
                                <tr key={`student-${studentIndex}`}>
                                  <td style={{ lineHeight: "2", verticalAlign: "middle" }}> 
                                    {student.name_student} 
                                  </td>
                                  <td style={{ lineHeight: "2", textAlign: "center", verticalAlign: "middle" }}> 
                                    {student.nisn} 
                                  </td>
                                  <td style={{ lineHeight: "2", textAlign: "center", verticalAlign: "middle" }}>
                                    <div>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: badge.color,
                                        marginBottom: '4px'
                                      }}>
                                        {badge.icon} {kkcaDesc}
                                      </div>
                                      <div style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: badge.color
                                      }}>
                                        {/* {studentAvg} */}
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ lineHeight: "2", textAlign: "center", verticalAlign: "middle" }}>
                                    <Button 
                                      color="primary" 
                                      size="sm" 
                                      onClick={() => {
                                        setSelectedStudentDetail(student);
                                        setSelectedStudentIndicators(indicators);
                                        setModalVisible(true);
                                      }}
                                    >
                                      Detail
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        {/* Modal Detail */}
                        <Modal isOpen={modalVisible} fullscreen toggle={() => setModalVisible(false)}>
                          <ModalHeader toggle={() => setModalVisible(false)}>
                            Detail Siswa - {selectedStudentDetail?.name_student || '-'} ({selectedStudentDetail?.nisn || '-'})
                          </ModalHeader>
                          <ModalBody>
                            <div style={{ overflowX: 'auto' }}>
                              <table className="table table-striped table-bordered w-100">
                                <thead>
                                  <tr>
                                    <th style={{textAlign: "center"}}>Nilai</th>
                                    <th>Indikator</th>
                                    <th>Element</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(selectedStudentIndicators || []).length === 0 && (
                                    <tr>
                                      <td colSpan={3} style={{textAlign:'center'}}>Tidak ada data indikator</td>
                                    </tr>
                                  )}
                                  {(selectedStudentIndicators || []).map((ind, idx) => (
                                    <tr key={`ind-${idx}`}>
                                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        {/* ✅ Show nilai_akhir (weighted average) instead of ysb_sub_element_value */}
                                        <strong>{ind.nilai_akhir || ind.ysb_sub_element_value || '-'}</strong>
                                        {ind.kkca_description && (
                                          <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '4px' }}>
                                            {ind.kkca_description}
                                          </div>
                                        )}
                                      </td>
                                      <td style={{ verticalAlign: 'middle' }}>
                                        {/* ✅ Use sub_element_name (NEW) or fallback to description */}
                                        {ind.sub_element_name || ind.description || '-'}
                                      </td>
                                      <td style={{ verticalAlign: 'middle' }}>
                                        {/* ✅ Use element_description for Element column */}
                                        {ind.element_description || '-'}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => setModalVisible(false)}>
                              Tutup
                            </Button>
                          </ModalFooter>
                        </Modal>
              </div>
            </div>
          </div>
        </Col>
    </div>
  </div>
  );
}
